'use client';

import React from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { useTranslation } from '@/i18n/client';
import { WithLocale } from '@/types/platform-data';
import { externalLinks } from '@/utils/constants';
import { buildUrl } from '@/utils/navigation';
import { createHeaderTestId } from '@/utils/string-utils';

export default function HeaderNavigation(props: WithLocale<{ isCalendar?: boolean }>) {
    const { t: tCo } = useTranslation(props.lang, 'common');

    const path = usePathname();

    const countrySlug = props.country?.slug || 'serbia';

    return (
        <nav className="ml-2.5 hidden items-center xl:flex">
            <Link
                href={buildUrl('', {
                    lang: props.lang,
                    children: [countrySlug],
                    fragment: props.isCalendar ? 'events' : undefined,
                })}
                scroll={!props.isCalendar}
                className={`mx-2 h-5 text-sm ${path.startsWith(`/${props.lang}/events`) || path === `/${props.lang}/${countrySlug}` ? 'border-b-2 border-solid border-accent' : 'hover:border-b-2 hover:border-solid hover:border-gray-300'}`}
                data-testid={createHeaderTestId({ name: 'home-link' })}
            >
                {tCo('events')}
            </Link>
            <Link
                href={buildUrl('', { lang: props.lang, children: [countrySlug, 'services'] })}
                className={`mx-2 h-5 text-sm ${path.startsWith(`/${props.lang}/services`) || path.startsWith(`/${props.lang}/${countrySlug}/services`) ? 'border-b-2 border-solid border-accent' : 'hover:border-b-2 hover:border-solid hover:border-gray-300'}`}
                data-testid={createHeaderTestId({ name: 'services-link' })}
            >
                {tCo('services')}
            </Link>
            <Link
                href={buildUrl('about', { lang: props.lang })}
                className={`mx-2 h-5 text-sm ${path === `/${props.lang}/about` ? 'border-b-2 border-solid border-accent' : 'hover:border-b-2 hover:border-solid hover:border-gray-300'}`}
                data-testid={createHeaderTestId({ name: 'about-link' })}
            >
                {tCo('about')}
            </Link>
            <Link
                href={buildUrl('collaboration', { lang: props.lang })}
                className={`mx-2 h-5 text-sm ${path === `/${props.lang}/collaboration` ? 'border-b-2 border-solid border-accent' : 'hover:border-b-2 hover:border-solid hover:border-gray-300'}`}
                data-testid={createHeaderTestId({ name: 'collaboration-link' })}
            >
                {tCo('collaboration')}
            </Link>
            <Link
                href={`${externalLinks.tickets[props.lang]}`}
                className={`mx-2 h-5 text-sm ${path === `/${props.lang}/collaboration` ? 'border-b-2 border-solid border-accent' : 'hover:border-b-2 hover:border-solid hover:border-gray-300'}`}
            >
                {tCo('tickets')}
            </Link>
        </nav>
    );
}
